import React from "react";

export const Loader = () => {
	return (
		<div className="d-flex flex-grow-1">
			{/*<Spinner animation="border" variant="primary"/>*/}
		</div>
	);
};
